import React from 'react';
import { OneLineInput } from '../⚛️atoms/OneLineInput';
import { TiptapEditor } from '../⚛️atoms/TiptapEditor';
import useLockedTranslate from '../../Hooks/useLockedTranslate';
import { getTranslation, updateTranslation } from '../../utils/translationHelper';
import { TranslateButton } from '../atoms/translateButton';
import { cloneWorkbookV2Value } from './editorUtils';

export const WorkbookV2Link = ({ item, updateItem, editing, openVideoDrawer, editingLanguage, workbook }) => {
  const { lang } = useLockedTranslate(workbook);

  const updateEditorItem = (updates) => {
    const nextItem = cloneWorkbookV2Value(item);
    nextItem.text = updates.text ?? nextItem.text;
    nextItem.page_number = updates.page_number ?? nextItem.page_number;
    nextItem.translations = updates.translations ?? nextItem.translations;
    nextItem.options = {
      ...(nextItem.options ?? {}),
      ...(updates.options ?? {})
    };
    updateItem(nextItem);
  };

  return (
    <div className={`flex w-full items-center gap-2 ${editing && 'border-pdteal rounded-lg border-2 px-8 py-12'}`}>
      {!editing && (
        <>
          {item.options?.target?.includes('vimeo') ? (
            <span
              className="text-pdteal underline hover:cursor-pointer"
              onClick={() => {
                openVideoDrawer();
              }}
            >
              {lang === 'en' ? item.text : getTranslation(item.translations, lang, 'text')}
            </span>
          ) : (
            <a className="text-pdteal underline" href={item.options?.target} target="_blank" rel="noreferrer">
              {lang === 'en' ? item.text : getTranslation(item.translations, lang, 'text', item.text)}
            </a>
          )}
        </>
      )}
      {editing && (
        <div className="grid w-full grid-cols-2 gap-8">
          <div className="relative">
            <p className="mb-2 text-xl/6 font-medium text-gray-900">Text</p>
            <TiptapEditor content={item.text} onChange={(value) => updateEditorItem({ text: value })} />
            {editingLanguage && (
              <TranslateButton
                text={item.text}
                language={editingLanguage}
                onResponse={(value) =>
                  updateEditorItem({
                    translations: updateTranslation(item.translations ?? {}, editingLanguage, 'text', value)
                  })
                }
              />
            )}
          </div>
          {editingLanguage && (
            <div>
              <p className="mb-2 text-xl/6 font-medium text-gray-900">Text ({editingLanguage})</p>
              <TiptapEditor
                content={getTranslation(item.translations, editingLanguage, 'text')}
                onChange={(value) =>
                  updateEditorItem({
                    translations: updateTranslation(item.translations ?? {}, editingLanguage, 'text', value)
                  })
                }
              />
            </div>
          )}
          <OneLineInput
            label="Target"
            value={item.options?.target}
            onChange={(value) => updateEditorItem({ options: { target: value } })}
          />
          <div className="w-2/5">
            <OneLineInput
              value={item.page_number}
              label="Page Number"
              onChange={(value) => updateEditorItem({ page_number: value })}
            />
          </div>
        </div>
      )}
    </div>
  );
};
